import React from 'react';
import WebsiteImage from 'components/WebsiteImage';
import HyperLink from 'components/Core/HyperLink';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const EventCard = (props) => {
  const { cover, title, description, eventDate, subTitle, ctaText, ctaLink } = props;
  return (
    <div className="flex flex-col rounded overflow-hidden shadow-lg h-full">
      {cover && (
        <div data-testid="card-cover">
          <WebsiteImage image={cover} />
        </div>
      )}
      <div data-testid="card-body" className="p-[32px] flex flex-col grow gap-[24px] md:gap-[30px]">
        <h4 className="m-0">{subTitle}</h4>
        <div className="flex gap-[24px] items-center">
          <CalendarTodayIcon className="text-[30px]" />
          <h5 className="m-0">{eventDate}</h5>
        </div>
        <div className="flex gap-[24px] items-center">
          <LocationOnIcon className="text-[30px]" />
          <div className="flex flex-col gap-[4px]">
            <p className="m-0">{title}</p>
            <h5 className="m-0">{description.description}</h5>
          </div>
        </div>
        {ctaLink && (
          <HyperLink
            data-testid="card-link"
            data-position="Body - Card CTA"
            ctaText={ctaText}
            className="card--link mt-auto"
            href={ctaLink}
          >
            {ctaText}
          </HyperLink>
        )}
      </div>
    </div>
  );
};

export default EventCard;
